import { render, staticRenderFns } from "./inputEmail.vue?vue&type=template&id=ec40be64&scoped=true"
import script from "./inputEmail.vue?vue&type=script&lang=js"
export * from "./inputEmail.vue?vue&type=script&lang=js"
import style0 from "./inputEmail.vue?vue&type=style&index=0&id=ec40be64&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec40be64",
  null
  
)

export default component.exports